"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUserProperties = exports.trackEvent = void 0;
const analytics_browser_1 = require("@amplitude/analytics-browser");
const Config_1 = __importDefault(require("./Config"));
const setUserProperties = ({ email, teamName }) => {
    const IdentifyObj = new analytics_browser_1.Identify();
    (0, analytics_browser_1.setUserId)(email);
    (0, analytics_browser_1.setGroup)('organization_id', teamName.toString().toLowerCase());
    IdentifyObj.set('organization_id', teamName.toString().toLowerCase());
    (0, analytics_browser_1.identify)(IdentifyObj);
};
exports.setUserProperties = setUserProperties;
const trackEvent = ({ event, eventProperties, env = 'performance' }) => {
    (0, analytics_browser_1.init)(env == 'performance' ? Config_1.default.amplitudeKey : Config_1.default.amplitudeKeyCulture, undefined, {
        serverUrl: Config_1.default.amplitudeAPIEndpoint + '/2/httpapi'
    });
    (0, analytics_browser_1.track)(event, eventProperties);
};
exports.trackEvent = trackEvent;
